import React from 'react';

function Navigation({ currentView, onViewChange }) {
  return (
    <div className="nv">
      <button 
        className={currentView === 'ov' ? 'on' : ''}
        onClick={() => onViewChange('ov')}
      >
        Overview
      </button>
      <button 
        className={currentView === 'cm' ? 'on' : ''}
        onClick={() => onViewChange('cm')}
      >
        Compare
      </button>
      <button 
        className={currentView === 'td' ? 'on' : ''}
        onClick={() => onViewChange('td')}
      >
        Technical
      </button>
      <button 
        className={currentView === 'sl' ? 'on' : ''}
        onClick={() => onViewChange('sl')}
      >
        Selector
      </button>
    </div>
  );
}

export default Navigation;
